// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".header[data-v-7ba18fa8]{color:#1c2634;font-size:18px;font-weight:600;text-align:center}.content[data-v-7ba18fa8]{display:flex;flex-direction:column}.content[data-v-7ba18fa8] .des{height:180px}.content>p[data-v-7ba18fa8]{font-size:18px;font-weight:500;line-height:34px;margin-left:46px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
